import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_USERS, ADD_USERS_FAILED, ADD_USERS_SUCCESS, UPDATE_USERS, UPDATE_USERS_FAILED, UPDATE_USERS_SUCCESS, USERS, USERS_FAILED, USERS_SUCCESS, USERSLIST } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"

export const getUsers = (options = {}) => async (dispatch) => {

  let module = 'users';
  let id = null;
  if (typeof options === 'object' && options !== null) {
    module = options.module || 'users';
    id = options.id || null;
  } else if (typeof options === 'string' || typeof options === 'number') {
    id = options;
  }
  dispatch({
    type: USERS,
  });

  try {
    let url = `users/usersList`;
    const queryParams = [];
    if (module) queryParams.push(`module=${module}`);
    if (id) queryParams.push(`id=${id}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    let response = await api(url, "get", {}, getAuthHeader());

    dispatch({
      type: USERS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Users list error ====>", error);
    return dispatch({
      type: USERS_FAILED,
      payload: error?.message,
    });
  }
};
export const listUsers = () => async (dispatch) => {
  dispatch({
    type: USERSLIST,
  });
  try {
    let response = await api(`users/listUsers`, "get", {}, getAuthHeader());
    dispatch({
      type: USERS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Users list error ====>", error);
    return dispatch({
      type: USERS_FAILED,
      payload: error?.message,
    });
  }
};
export const addUsers = (data) => async dispatch => {
  dispatch({
    type: ADD_USERS
  })
  try {
    let response = await api(`users/add`, 'post', data, getAuthHeader())
    console.log('add users data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_USERS_SUCCESS,
      payload: response?.data
    })
    await dispatch(getUsers({ module: "employee" }))
    return response
  } catch (error) {
    console.log("while Adding users error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_USERS_FAILED,
      payload: error?.message
    })
  }
}

export const updateUsers = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_USERS
  })
  try {
    let response = await api(`users/update/${id}`, 'put', data, getAuthHeader())
    console.log('update users data', response);
    toast.success("Updated Successfully");
    let mergedUser;

    if (response?.data?.updateLocalStorage) {
      const localUserStr = localStorage.getItem('user');
      if (localUserStr) {
        const localUser = JSON.parse(localUserStr);
        const updatedUser = response.data?.response || {};

        mergedUser = {
          ...localUser,
          ...updatedUser,
          accessToken: updatedUser?.accessToken || localUser?.accessToken,
          refreshToken: updatedUser?.refreshToken || localUser?.refreshToken,
          exp: updatedUser?.exp || localUser?.exp
        };

        const changed = Object.keys(updatedUser).some(
          key => updatedUser[key] !== localUser[key]
        );

        if (changed) {
          localStorage.setItem('user', JSON.stringify(mergedUser));
        }
      }
    }
    dispatch({
      type: UPDATE_USERS_SUCCESS,
      // payload: response?.data?.response
      payload: {
        updateLocalStorage: response?.data?.updateLocalStorage,
        response: mergedUser,
      },

    })
    await dispatch(getUsers({ module: "employee" }))
    return response
  } catch (error) {
    console.log("while updating users error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_USERS_FAILED,
      payload: error?.message
    })
  }
}